const getRoomBedsLabel = (roombeds: number) => {
  if (roombeds === 1) return 'SGL';
  if (roombeds === 2) return 'DBL';
  if (roombeds === 3) return 'TPL';
  if (roombeds === 4) return 'QDP';
  return `${roombeds} total beds`;
};

export { getRoomBedsLabel };
